/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe, Right } from 'purify-ts';
import p from 'vue-strict-prop';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function valueRequired(val, onError) {
    return val.chain(maybe => maybe.toEither(new Error(onError ?? 'Input is required')));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function makeInputValue(x) {
    return Right(Maybe.fromNullable(x));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const numberInputValue = (x) => makeInputValue(x);
/**
 * A number input validator that checks that the value is an integer.
 *
 * @param value The value to check.
 * @returns Maybe an error, if the number is not an integer.
 */
export function numberIsIntegerValidator(value) {
    if (Number.isInteger(value)) {
        return Maybe.empty();
    }
    return Maybe.of(new Error('The value should be an integer'));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function valueProp() {
    return p.ofType();
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function valuePropNoError() {
    return p.ofType();
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function mapValue(value, mapper) {
    return value.map(maybe => maybe.map(val => mapper(val)));
}
